/**
 * 财务科路由
 */

const financeRoutes = [
  {
    path: 'material-store',
    name: 'material-store',
    meta: {
      title: '耗材出入库',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/material-store-new.vue'], resolve)
  },
  {
    path: 'material-runtime-store',
    name: 'material-runtime-store',
    meta: {
      title: '耗材库存',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/material-runtime-store.vue'], resolve)
  },
  {
    path: 'medicine-fee',
    name: 'medicine-fee',
    meta: {
      title: '药品收费项目',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => {
      if (process.env.HOSPITAL === 'runsheng' || process.env.HOSPITAL === 'houzhai') {
        return require(['../views/page/finance/medicine-fee-runsheng.vue'], resolve)
      }
      return require(['../views/page/finance/medicine-fee.vue'], resolve)
    }
  },
  {
    path: 'treat-fee',
    name: 'treat-fee',
    meta: {
      title: '诊疗收费项目',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/treat-fee.vue'], resolve)
  },
  {
    path: 'other-fee',
    name: 'other-fee',
    meta: {
      title: '其他收费项目',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/other-fee.vue'], resolve)
  },
  {
    path: 'treat-package',
    name: 'treat-package',
    meta: {
      title: '诊疗组套',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/treat-package.vue'], resolve)
  },
  {
    path: 'treat-package-user',
    name: 'treat-package-user',
    meta: {
      title: '诊疗组套查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/treat-package-user.vue'], resolve)
  },
  {
    path: 'treat-package-classify',
    name: 'treat-package-classify',
    meta: {
      title: '诊疗组套分类',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/treat-package-classify.vue'], resolve)
  },
  {
    path: 'treat-package-switch',
    name: 'treat-package-switch',
    meta: {
      title: '诊疗组套显隐',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/treat-package-switch.vue'], resolve)
  },
  // 财务科的 字典
  {
    path: 'dictionary-feiyongbinggui',
    name: 'dictionary-feiyongbinggui',
    meta: {
      title: '费用归并',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-feiyongbinggui.vue'], resolve)
  },
  {
    path: 'dictionary-fapiaoguibing',
    name: 'dictionary-fapiaoguibing',
    meta: {
      title: '发票归并',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-fapiaoguibing.vue'], resolve)
  },
  {
    path: 'dictionary-fapiao',
    name: 'dictionary-fapiao',
    meta: {
      title: '发票归并',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-fapiaoguibing.vue'], resolve)
  },
  {
    path: 'dictionary-feiyong',
    name: 'dictionary-feiyong',
    meta: {
      title: '费用归并',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-feiyongbinggui.vue'], resolve)
  },
  {
    path: 'dictionary-yaowuyibao',
    name: 'dictionary-yaowuyibao',
    meta: {
      title: '药品医保目录管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/dictionary/dictionary-yaowuyibao.vue'], resolve)
  },
  {
    path: 'dictionary-zhengliaoyibao',
    name: 'dictionary-zhengliaoyibao',
    meta: {
      title: '诊疗医保目录管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/dictionary/dictionary-zhengliaoyibao.vue'], resolve)
  },
  {
    path: 'statistics-invoice',
    name: 'statistics-invoice',
    meta: {
      title: '发票统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/statistics-invoice.vue'], resolve)
  },
  {
    path: 'statistics-charge-type',
    name: 'statistics-charge-type',
    meta: {
      title: '收费类型统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/statistics-charge-type.vue'], resolve)
  },
  {
    path: 'statistics-outpatient-cost',
    name: 'statistics-outpatient-cost',
    meta: {
      title: '门诊收费统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/statistics-outpatient-cost.vue'], resolve)
  },
  {
    path: 'statistics-group-category',
    name: 'statistics-group-category',
    meta: {
      title: '组套分类统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/statistics-group-category.vue'], resolve)
  },
  {
    path: 'statistics-treatment-times',
    name: 'statistics-treatment-times',
    meta: {
      title: '门诊数量统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/statistics-treatment-times.vue'], resolve)
  },
  {
    path: 'statistics-drug',
    name: 'statistics-drug',
    meta: {
      title: '药品销量统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/statistics-drug.vue'], resolve)
  },
  {
    path: 'statistics-yibao',
    name: 'statistics-yibao',
    meta: {
      title: '医保结算统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/statistics-yibao.vue'], resolve)
  },
  {
    path: 'statistics-category-items',
    name: 'statistics-category-items',
    meta: {
      title: '二类苗数量统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/statistics-category-items.vue'], resolve)
  },
  {
    path: 'supplier-management',
    name: 'supplier-management',
    meta: {
      title: '供应商管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/supplier-information-maintenance.vue'], resolve)
  },
  {
    path: 'factory-management',
    name: 'factory-management',
    meta: {
      title: '厂家管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/factory-management.vue'], resolve)
  },
  {
    path: 'charge-config',
    name: 'charge-config',
    meta: {
      title: '治疗项目附加费用',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/finance/charge-config.vue'], resolve)
  }
]

export default financeRoutes
